import {
  onSocketNewMessage,
  onSocketStatusUpdate,
  onSocketRating,
  socketNewTicket,
} from "../../features/supportTickets/supportTicketsSlice";

const listenerRegistry = new WeakMap();

// Admin sockets auto-join the `tickets:admin` room on connect, so these
// broadcasts arrive for every ticket without joining per-ticket rooms. The
// message/status/rating handlers go through thunks so an update for a ticket
// that isn't in the loaded list still surfaces (ensureTicketLoaded).
export const supportTicketsListeners = (socket, dispatch) => {
  if (listenerRegistry.has(socket)) {
    const prev = listenerRegistry.get(socket);
    socket.off("ticket:newMessage", prev.newMessage);
    socket.off("ticket:statusUpdate", prev.statusUpdate);
    socket.off("ticket:rating", prev.rating);
    socket.off("ticket:new", prev.newTicket);
  }

  const newTicketHandler = (data) => dispatch(socketNewTicket(data));
  const newMessageHandler = (data) => dispatch(onSocketNewMessage(data));
  const statusUpdateHandler = (data) => dispatch(onSocketStatusUpdate(data));
  const ratingHandler = (data) => dispatch(onSocketRating(data));

  socket.on("ticket:new", newTicketHandler);
  socket.on("ticket:newMessage", newMessageHandler);
  socket.on("ticket:statusUpdate", statusUpdateHandler);
  socket.on("ticket:rating", ratingHandler);
  listenerRegistry.set(socket, {
    newTicket: newTicketHandler,
    newMessage: newMessageHandler,
    statusUpdate: statusUpdateHandler,
    rating: ratingHandler,
  });
};
